$(document).ready(function() {
	$(document).on('click', '.js-all-video-more', function() {
		var allVideo = $(this).parents('.js-all-video');
		allVideo.toggleClass('opened');
		if (allVideo.hasClass('opened')) {
			allVideo.find('.js-all-video-list').slideDown();
		} else {
			allVideo.find('.js-all-video-list').slideUp();
		}
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/longrid/all-video-more.js